import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import styles from './TransationReciept.module.css';
import { LanguageContext } from '../LanguageContext/LanguageContext';
import ProfileNavigation from '../ProfileNavigation/ProfileNavigation';
import { useLocation } from "react-router-dom";
import Notification from '../Notification/Notification';
import riyals from "./riyals.svg";
const marketingBackendUrl = import.meta.env.VITE_MARKETING_BACKEND_URL;
function TransationReciept() {
  const [transactions, setTransactions] = useState([]);
  const [courses, setCourses] = useState([]);
  const [userId, setUserId] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { direction } = useContext(LanguageContext);
  const [currentPage, setCurrentPage] = useState(1);
  const transactionsPerPage = 4;
  const [searchTerm, setSearchTerm] = useState('');
  const [notification, setNotification] = useState({ message: '', isVisible: false });

  const email = localStorage.getItem("useremailidis");
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  const showNotification = (message) => {
    setNotification({ message, isVisible: true });
  };

  const hideNotification = () => {
    setNotification({ ...notification, isVisible: false });
  };

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, [location.pathname]);

  useEffect(() => {
    const fetchUserId = async () => {
      try {
        if (!email) {
          throw new Error(direction === "rtl" 
            ? "البريد الإلكتروني غير موجود" 
            : "Email not found");
        }

        const response = await axios.get(`${marketingBackendUrl}/maflam/user/email/${email}`);
        
        if (!response.data) {
          throw new Error(direction === "rtl" 
            ? "لم يتم العثور على بيانات المستخدم" 
            : "User data not found");
        }
        
        if (response.data && response.data._id) {
          setUserId(response.data._id);
        } else {
          throw new Error(direction === "rtl" 
            ? "معرف المستخدم غير موجود" 
            : "User ID not found");
        }
      } catch (error) {
        console.error("Error fetching user ID:", error);
        setError(direction === "rtl" 
          ? `خطأ في جلب معرف المستخدم: ${error.message}` 
          : `Error fetching user ID: ${error.message}`);
        showNotification(direction === "rtl" 
          ? "فشل في تحميل بيانات المستخدم" 
          : "Failed to load user data");
      }
    };

    if (email) {
      fetchUserId();
    } else {
      setError(direction === "rtl" 
        ? "البريد الإلكتروني غير موجود في التخزين المحلي" 
        : "Email not found in localStorage");
      showNotification(direction === "rtl" 
        ? "معلومات المستخدم غير متوفرة" 
        : "User information not available");
    }
  }, [email, direction]);

  useEffect(() => {
    const fetchTransactions = async (userId) => {
      try {
        const response = await axios.get(`${marketingBackendUrl}/maflam/transactions/user/${userId}`);
        
        if (response.data && response.data.length > 0) {
          // Reverse the transactions to get the latest first
          const reversedTransactions = response.data.reverse();

          // Create a map to store the latest transaction for each reference
          const latestTransactionsMap = new Map();

          reversedTransactions.forEach(transaction => {
            // Check if it's a Tabby payment
            const isTabbyPayment = transaction.transactionData.status === "AUTHORIZED";
            
            // Get the reference ID based on payment type
            const referenceId = isTabbyPayment 
              ? transaction.transactionData.id 
              : transaction.transactionData.tran_ref;

            // For Tabby payments, always add them
            // For regular payments, only add if it's not already in the map
            if (isTabbyPayment || !latestTransactionsMap.has(referenceId)) {
              latestTransactionsMap.set(referenceId, transaction);
            }
          });

          // Convert the map back to an array
          const latestTransactions = Array.from(latestTransactionsMap.values());

          setTransactions(latestTransactions);

        } else {
          setError(direction === "rtl" 
            ? "لا توجد بيانات معاملات متاحة" 
            : "No transaction data available");
        }
      } catch (error) {
        console.error("Error fetching transactions:", error.message);
        setError(direction === "rtl" 
          ? "فشل في تحميل المعاملات" 
          : "Failed to load transactions");
        showNotification(direction === "rtl" 
          ? "فشل في تحميل بيانات المعاملات" 
          : "Failed to load transaction data");
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchTransactions(userId);
    }
  }, [userId, direction]);

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await fetch(`${marketingBackendUrl}/maflam/courses`);
        
        if (!response.ok) {
          throw new Error(direction === "rtl" 
            ? `فشل في جلب الدورات: ${response.status}` 
            : `Failed to fetch courses: ${response.status}`);
        }
        
        const data = await response.json();
         
        if (!data || !Array.isArray(data.courses)) {
          throw new Error(direction === "rtl" 
            ? "تنسيق بيانات الدورة غير صالح" 
            : "Invalid course data format");
        }
        
        const sortedCourses = data.courses.sort((a, b) => {
          const rankingA = parseFloat(a.CourseRankingEnglish) || 0;
          const rankingB = parseFloat(b.CourseRankingEnglish) || 0;
          return rankingA - rankingB;
        });

        setCourses(sortedCourses);
      } catch (err) {
        console.error("Error fetching courses:", err);
        setError(direction === "rtl" 
          ? `فشل في تحميل الدورات: ${err.message}` 
          : `Failed to load courses: ${err.message}`);
        showNotification(direction === "rtl" 
          ? "فشل في تحميل بيانات الدورات" 
          : "Failed to load course data");
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [direction]);

  const downloadPDF = async (invoiceUrl) => {
    try {

      const response = await axios.get(`${marketingBackendUrl}/maflam/generate-pdf?url=${encodeURIComponent(invoiceUrl)}`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'invoice.pdf');
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading PDF:", error);
    }
  };

  const indexOfLastTransaction = currentPage * transactionsPerPage;
  const indexOfFirstTransaction = indexOfLastTransaction - transactionsPerPage;
  const currentTransactions = transactions.slice(indexOfFirstTransaction, indexOfLastTransaction);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const filteredTransactions = currentTransactions.filter(transaction => {
    const course = courses.find(course => course._id === transaction.courseId);
    return course && course.CourseNameArabic.toLowerCase().includes(searchTerm.toLowerCase());
  });

  const convertInvoiceUrl = (url) => {
    try {
      if (!url) return '#';
      const updatedUrl = url.replace('/view/', '/download/');

      return updatedUrl;
    } catch (error) {
      console.error("Error converting invoice URL:", error);
      return '#';
    }
  };

  const renderTransaction = (transaction) => {
    try {
      // Check if transaction data exists
      if (!transaction || !transaction.transactionData) {
        return (
          <div className={styles.transactionCard}>
            <div className={styles.cardHeader}>
              <div className={styles.headerInfo}>
                <p style={{color: '#ff4d4d'}}>
                  {direction === "rtl" 
                    ? "بيانات المعاملة غير متوفرة" 
                    : "Transaction data not available"}
                </p>
              </div>
            </div>
          </div>
        );
      }

      // Handle both payment schemas
      const isTabbyPayment = transaction.transactionData.status === "AUTHORIZED";
      const transactionDetails = isTabbyPayment ? {
        name: transaction.transactionData.buyer?.name || "N/A",
        email: transaction.transactionData.buyer?.email || "N/A",
        amount: transaction.transactionData.amount || "N/A",
        status: transaction.transactionData.status || "N/A",
        reference: transaction.transactionData.id || "N/A",
        date: transaction.transactionData.created_at || transaction.createdAt,
        response_message: transaction.transactionData.status === "AUTHORIZED" ? "Authorised" : "Declined"
      } : {
        name: transaction.transactionData.customer_details?.name || "N/A",
        email: transaction.transactionData.customer_details?.email || "N/A",
        amount: transaction.transactionData.cart_amount || "N/A",
        status: transaction.transactionData.payment_result?.response_status || "N/A",
        reference: transaction.transactionData.tran_ref || "N/A",
        date: transaction.transactionData.payment_result?.transaction_time || transaction.createdAt,
        response_message: transaction.transactionData.payment_result?.response_message || "N/A"
      };

      const course = courses.find(course => course._id === transaction.courseId);

      // Check if it's a failed transaction
      if (transactionDetails.amount === "N/A") {
        return (
          <div key={transaction._id} className={styles.transactionCard}>
            <div className={styles.cardHeader}>
              <div className={styles.headerInfo}>
                <p>
                  <strong style={{color: 'rgb(57, 255, 251)'}}>
                    {direction === "rtl" ? "تاريخ إنشاء المعاملة : " : "Transaction Created On : "}
                  </strong>
                  {new Date(transactionDetails.date).toLocaleString().toUpperCase()}
                </p>
              </div>
            </div>

            <div className={styles.orderDetails}>
              <div className={styles.leftColumn}>
                <div className={styles.detailRow}>
                  <strong>{direction === "rtl" ? "اسم الدورة : " : "Course Name : "}</strong> 
                  <p>{course ? course.CourseNameArabic.toUpperCase() : 'N/A'}</p>
                </div>
                <div className={styles.detailRow}>
                  <p style={{color: '#ff4d4d', width: '100%', textAlign: 'center', fontSize: '1.1rem'}}>
                    {direction === "rtl" ? "معاملة فاشلة" : "Failed Transaction"}
                  </p>
                </div>
              </div>
              {course && (
                <div className={styles.thumbnailContainer}>
                  <img 
                    src={course.ThumbnailArabic} 
                    alt={course.CourseNameArabic} 
                    className={styles.thumbnail}
                  />
                </div>
              )}
            </div>
          </div>
        );
      }

      // Original render code for successful transactions
      return (
        <div key={transaction._id} className={styles.transactionCard}>
          <div className={styles.cardHeader}>
            <div className={styles.headerInfo}>
              <p>
                <strong style={{color: 'rgb(57, 255, 251)'}}>
                  {direction === "rtl" ? "تاريخ إنشاء المعاملة : " : "Transaction Created On : "}
                </strong>
                {new Date(transactionDetails.date).toLocaleString().toUpperCase()}
              </p>
            </div>
          </div>

          <div className={styles.orderDetails}>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} className={styles.CardParent}>
              <div className={styles.leftColumn}>
                <div className={styles.detailRow}>
                  <strong>{direction === "rtl" ? "إجمالي الطلب : " : "Order Total : "}</strong> 
                  <p>
                    {transactionDetails.amount}
                    {" "}
                    <img src={riyals} alt="SAR" className={styles.riyalsIcon} />
                  </p>
                </div>
                
                <div className={styles.detailRow}>
                  <strong>{direction === "rtl" ? "اسم الدورة : " : "Course Name : "}</strong> 
                  <p>{course ? course.CourseNameArabic.toUpperCase() : 'N/A'}</p>
                </div>

                <div className={styles.detailRow}>
                  <strong>{direction === "rtl" ? "الاسم الكامل للمستخدم : " : "User Full Name : "}</strong> 
                  <p>{transactionDetails.name.toUpperCase()}</p>
                </div>

                <div className={styles.detailRow}>
                  <strong>{direction === "rtl" ? "مرجع المعاملة : " : "Transaction Reference : "}</strong> 
                  <p>{transactionDetails.reference.toUpperCase()}</p>
                </div>                    
              </div>
              <div>
                {course && (
                  <div className={styles.thumbnailContainer}>
                    <img 
                      src={course.ThumbnailArabic} 
                      alt={course.CourseNameArabic} 
                      className={styles.thumbnail}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className={styles.rightColumn}>
              <div className={styles.statusSection}>
                <div className={styles.detailRow}>
                  <strong>
                    {direction === "rtl" 
                      ? (transactionDetails.response_message === 'Declined' ? "فشل إنشاء الفاتورة" : "تاريخ إنشاء الفاتورة") 
                      : (transactionDetails.response_message === 'Declined' ? "Invoice Generation Failed At :" : "Invoice Generated On :")}
                  </strong> 
                  <p>{new Date(transaction.updatedAt).toLocaleString().toUpperCase()}</p>
                </div>
                <div className={styles.detailRow}>
                  <strong>{direction === "rtl" ? "المبلغ : " : "Amount : "}</strong> 
                  <p>{transactionDetails.amount.toString().toUpperCase()}</p>
                </div>
                <div className={styles.detailRow}>      
                  <strong>{direction === "rtl" ? "الحالة : " : "Status : "}</strong>  
                  <p className={transactionDetails.response_message === 'Declined' ? styles.declined : styles.approved}>
                    {transactionDetails.response_message.toUpperCase()}
                  </p>
                </div>
                {transactionDetails.response_message === 'Authorised' && transaction.invoiceId && (
                  <div className={styles.invoiceLinkContainer}>
                    {transaction.invoiceId.invoiceUrl && (
                      <>
                        <a
                          className={styles.downloadButton}
                          href={transaction.invoiceId.invoiceUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {direction === "rtl" ? "عرض الفاتورة" : "View Invoice"}
                        </a>
                        <a
                          className={styles.downloadButton}
                          href={convertInvoiceUrl(transaction.invoiceId.invoiceUrl)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {direction === "rtl" ? "تحميل الفاتورة" : "Download Invoice"}
                        </a>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      );
    } catch (err) {
      console.error("Error rendering transaction:", err);
      return (
        <div className={styles.transactionCard}>
          <div className={styles.cardHeader}>
            <div className={styles.headerInfo}>
              <p style={{color: '#ff4d4d'}}>
                {direction === "rtl" 
                  ? "خطأ في عرض بيانات المعاملة" 
                  : "Error displaying transaction data"}
              </p>
            </div>
          </div>
        </div>
      );
    }
  };

  return (
    <div className={styles.container} style={{ direction: direction }}>
      <Notification 
        message={notification.message}
        isVisible={notification.isVisible}
        onClose={hideNotification}
      />
      
      {isLoading && (
        <div className={styles.loaderWrapper}>
          <span className={styles.loader}></span>
        </div>
      )}

      <ProfileNavigation />
      
      <input
        type="text"
        placeholder={direction === "rtl" ? "البحث عن المعاملات..." : "Search transactions..."}
        className={styles.searchInput}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {loading ? (
        <div className={styles.noDataMessage}>
          {direction === "rtl" ? "جاري التحميل..." : "Loading..."}
        </div>
      ) : error ? (
        <div className={styles.noDataMessage}>
          {direction === "rtl" 
            ? "لا توجد معاملات متاحة حاليًا، يرجى المحاولة مرة أخرى لاحقًا" 
            : "No transactions available at the moment, please try again later"}
        </div>
      ) : transactions.length === 0 ? (
        <div className={styles.noDataMessage}>
          {direction === "rtl" 
            ? "لا توجد معاملات متاحة" 
            : "No transactions available"}
        </div>
      ) : (
        <div className={styles.transactionContainer}>
          {filteredTransactions.map(transaction => {
            try {
              return renderTransaction(transaction);
            } catch (err) {
              console.error("Error rendering transaction:", err, transaction);
              return null;
            }
          }).filter(Boolean)}
        </div>
      )}

      {!loading && !error && transactions.length > 0 && (
        <div className={styles.pagination}>
          {Array.from({ length: Math.ceil(filteredTransactions.length / transactionsPerPage) }, (_, index) => (
            <button
              key={index + 1}
              onClick={() => paginate(index + 1)}
              className={currentPage === index + 1 ? styles.activePage : ''}
            >
              {index + 1}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default TransationReciept;